const sob = [

    {label:"Severity (mMRC Scale)",
    controlType:"radio button",
    options:["0 :strenuous exercise","1 :hurrying /hills", "2 :on level ground", "3 :<100yds level ground", "4 :in the house" ]
    },

    {label:"Orthopnoea",
    controlType:"radio button",
    options:["Yes","No"]
    },
   
    {
    label:"Frequency",
    controlType:"radio button",
    options:[" Every day","Most days", "Weekly", "Evey couple of weeks", "Monthly", "Occasionally"]
    },

    {
    label:"Present for several:",
    controlType:"radio button",
    options:["Days","Weeks","Months","Years"]
    },

 {label:"Any precipitating factors:",
    controlType:"text area",
    options:["Yes","No",]
    },

]

export default sob
    